export const API_URL = 'https://api.theorieflix.nl/api/v2';


export const INACTIVITY_TIME = 120;